import React from 'react';
import propTypes from './propTypes';

const FieldDiary = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M19.9368 11.4124V1L15.0819 2.21372C13.8584 2.51961 13 3.61899 13 4.88021V12.2514C13 13.7692 14.23 15 15.7482 15H22.9144V3.36695H21.0821V13.1676H15.7482C15.6264 13.1676 15.4711 13.1676 15.3162 13.1549C14.8963 13.1202 14.8421 12.7422 15.2429 12.6121C15.4017 12.5605 15.5769 12.5135 15.7385 12.47C15.7814 12.4585 15.8234 12.4473 15.8638 12.4362C16.9529 12.1392 17.7958 11.923 18.3649 11.7815C18.6494 11.7107 18.8655 11.6586 19.0097 11.6243C19.0819 11.6072 19.136 11.5945 19.1718 11.5862L19.2115 11.577L19.2235 11.5743L19.9368 11.4124ZM15.3817 10.6684C15.1879 10.7213 15.0046 10.7779 14.8324 10.8389V4.88021C14.8324 4.4598 15.1185 4.09334 15.5263 3.99138L15.6211 3.96768V10.6033C15.5426 10.6246 15.4628 10.6463 15.3817 10.6684ZM17.0293 10.2301V3.61563L18.1045 3.34685V9.95828L17.9226 10.0033C17.6741 10.0651 17.3757 10.1405 17.0293 10.2301Z" fill="currentColor" />
    <path d="M11.5 6L6 6V4H4V6L2 6V8H4V18H2V20H4V22H6V20L16 20V22H18V20H20V18H18V16.4998H16V18L6 18V8L11.5 8V6Z" fill="currentColor" />
    <path d="M17.9226 10.0031C17.6964 10.0593 17.4287 10.1269 17.1211 10.2062L17.0293 10.2299C17.3757 10.1403 17.6741 10.0649 17.9226 10.0031Z" fill="currentColor" />
  </svg>
);

FieldDiary.propTypes = propTypes;

export default FieldDiary;
